<template>
  <v-form>
    <v-container>

      <!-- Título -->
      <v-col cols="12">
        <h2>Recepción Rayos X</h2>
      </v-col>

      <!-- Búsqueda -->
      <v-col cols="6" md="4">
        <v-alert
          outlined
          type="warning"
          prominent
          border="left"
        >
          Solo se mostrarán las citas del día actual.
        </v-alert>
      </v-col>
      <v-sheet
        class="pa-4 mb-6"
        rounded="lg"
        elevation="1"
      >
        <v-row align="center">
        <v-col cols="12" md="3">
          <v-text-field
            v-model="expPaciente"
            label="Número de expediente del paciente"
            outlined
            shaped
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="8"
            @input="soloNumeros('expPaciente',8)"
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model="folioCita"
            label="Folio de la cita"
            outlined
            shaped
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="6"
            @input="soloNumeros('folioCita',6)"
          />
        </v-col>

          <v-col cols="12" md="6" class="d-flex align-end">
            <v-btn
              color="success"
              rounded
              dark
              class="mr-2"
              @click="buscaCita"
            >
              <v-icon left>mdi-text-box-search</v-icon>
              Buscar cita
            </v-btn>

            <v-btn
              color="warning"
              rounded
              dark
              @click="limpiarBusqueda"
            >
              <v-icon left>mdi-broom</v-icon>
              Limpiar búsqueda
            </v-btn>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" md="6" class="d-flex align-end">
            <v-btn
            color="blue lighten-1"
              rounded
              dark
              class="mr-2"
              :disabled="!cita || horaRecepcion || fechaCancelacion || citaPasada || internamientoActivo"
              @click="recibePaciente"
            >
              <v-icon left>mdi-account-arrow-right</v-icon>
              Recibir al paciente
            </v-btn>
            <!--
            <v-btn
            color="teal darken-1"
              rounded
              dark
              @click="buscaSignos"
              :disabled="!puedeRegistrarSignos"
              >
              <v-icon left>mdi-heart-pulse</v-icon>
              Registrar signos vitales
            </v-btn>
            -->
          </v-col>
        </v-row>
      </v-sheet>
        <v-row>
        <!-- Alertas -->
          <v-col cols="12" class="d-flex align-end">
            <v-alert
              text
              dense
              color="teal"
              icon="mdi-check-circle"
              border="left"
              v-if="cita && cita.horaRecepcion"
            >
              El paciente ya ha sido recibido en {{ formateaFecha(cita.horaRecepcion) }}.
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="d-flex align-end">
            <v-alert
              text
              dense
              color="red"
              icon="mdi-close-circle"
              border="left"
              v-if="fechaCancelacion"
            >
              La cita ha sido cancelada el {{ cita.fechaCancelado }} - {{ cita.observacionesCancelado }}. No se pueden realizar acciones sobre esta cita.
            </v-alert>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="d-flex align-end">
            <v-alert
              icon="mdi-information"
              prominent
              text
              type="info"
              v-if="conflictos"
            >
              El paciente tiene multiples citas el día de hoy. <br>
              <div v-for="conf in cita.conflicto" :key="conf.id">
                Folio de la cita: {{ conf.id }} a las {{ conf.startDate }}, con {{ conf.medico }}
              </div>
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="d-flex align-end">
              <v-alert
                dense
                border="left"
                type="warning"
                v-if="citaPasada"
              >
                La cita encontrada tiene una fecha {{ cita.estadoCita }}. No se pueden realizar acciones sobre esta cita.
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex align-end">
              <v-alert
                v-model="alert"
                color="cyan"
                border="left"
                elevation="2"
                colored-border
                icon="mdi-calendar-clock"
                v-if="tiempoDeCita"
                >
                {{cita.tiempoCita}}
              </v-alert>
            </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="d-flex align-end">
            <v-alert
              text
              dense
              color="red"
              icon="mdi-close-circle"
              border="left"
              v-if="internamientoActivo"
            >
              El paciente tiene una cita activa en {{ cita.internamientoActivo }}. No se puede recibir hasta ser egresado.
            </v-alert>
          </v-col>
        </v-row>

      <!-- Datos de la cita -->
      <v-sheet
        class="pa-4"
        color="grey lighten-5"
        rounded="lg"
        elevation="1"
      >
        <h2 class="mb-4">Datos de la cita</h2>

        <v-row>
          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Folio de la cita</div>
            <div class="value" v-if="cita">
              {{ cita.citaId }}
            </div>
            <div class="value " v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Tipo</div>
            <div class="value" v-if="cita">{{ cita.tipo }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Paciente</div>
            <div class="value" v-if="cita">{{ cita.paciente }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="3">
            <div class="label font-weight-bold">Edad</div>
            <div class="value" v-if="cita">{{ cita.edad }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Médico</div>
            <div class="value" v-if="cita">{{ cita.medico }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Consultorio</div>
            <div class="value" v-if="cita">{{ cita.consultorio }}</div>
            <div class="value" v-else>-</div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="label font-weight-bold">Fecha de la cita</div>
            <div class="value" v-if="cita">{{ cita.fecha }}</div>
            <div class="value" v-else>-</div>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet
        class="pa-4 mt-6"
        color="grey lighten-5"
        rounded="lg"
        elevation="1"
        >
        <v-col cols="12" md="6">
            <div class="label font-weight-bold">Creado por</div>
            <div class="value" v-if="cita">{{ cita.creado}}</div>
            <div class="value" v-else><v-divider class="my-2"></v-divider></div>
          </v-col>
        <v-col cols="12" md="6">
            <div class="label font-weight-bold" v-if="cita && cita.observacionesIngreso">Observaciones del ingreso</div>
            <div class="value" v-if="cita && cita.observacionesIngreso">{{ cita.observacionesIngreso }}</div>
            <div class="value" v-else><v-divider class="my-2"></v-divider></div>
          </v-col>
        <v-col cols="12" md="6">
            <div class="label font-weight-bold" v-if="cita && cita.observacionesCancelado">Observaciones de cancelación</div>
            <div class="value" v-if="cita && cita.observacionesCancelado">{{ cita.observacionesCancelado }}</div>
            <div class="value" v-else><v-divider class="my-2"></v-divider></div>
          </v-col>
      </v-sheet>
      <DialogSelectCita
        v-model="dialogSelectCita"
        :citas="citasEncontradas"
        @cita-seleccionada="citaSeleccionada"
      />
      <!--
      <v-dialog v-model="dialogSignos" max-width="600">
        <Signos
        @cerrar="dialogSignos = false"
        :signos="signosSomato"
        @guardado="signosGuardados"
        />
      </v-dialog>
    -->
    </v-container>
  </v-form>
</template>


<script>
import Swal from "sweetalert2"
import 'sweetalert2/dist/sweetalert2.min.css'
import DialogSelectCita from "./DialogSelectCita.vue";
//import Signos from "./Signos.vue";

export default {
  name: 'raoysX',
  components: {
    DialogSelectCita,
    //Signos
  },
  data() {
  return {
    loadingBuscaCita: false,
    cita: null,
    expPaciente: '',
    folioCita: '',
    dialogSelectCita: false,
    dialogSignos: false,
    citasEncontradas: [],
    signosSomato: []
  }
},
  methods: {
  async buscaCita () {
  this.loadingBuscaCita = true

  try {
    //let identificador = ''
    // Validación
    if(this.expPaciente != ''){
        if(this.expPaciente < 10000009) {
        Swal.fire({
            icon: 'warning',
            title: 'El número de expediente no es válido'
        })
        return
        }
    }else if(this.folioCita != ''){
        if (!this.folioCita || this.folioCita < 100) {
        Swal.fire({
            icon: 'warning',
            title: 'El número de folio no es válido'
        })
        return
        }
    }else {
        Swal.fire({
            icon: 'warning',
            title: 'Ingrese un criterio de búsqueda'
        })
        return
    }
    // Llamada al backend
    const response = await this.$http({
      url: 'consulta/getCitav3',
      method: 'GET',
      params: {
    id: this.folioCita || null,
    expediente: this.expPaciente || null
    }
    })
    if (response.data.root.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No se encontrarón registros de citas con el criterio proporcionado. Verifique los datos y la fecha de la cita.'
      })
      this.cita = null
      return
    }  if(response.data.root.length === 1){
      this.cita = response.data.root[0]
    }
    else if (response.data.root.length > 1) {
      this.citasEncontradas = response.data.root
      this.dialogSelectCita = true
    }

  } catch (err) {
    console.error(err)
    this.cita = null

    this.$store.dispatch('security/revisaError', err)

  } finally {
    this.loadingBuscaCita = false
  }
  },
  async recibePaciente(){
    try {
      const confirmacion = await Swal.fire({
      title: '¿Confirmar recepción?',
      text: '¿Realmente desea recibir al paciente?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, recibir',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    })

    // Si el usuario cancela, se detiene el método
    if (!confirmacion.isConfirmed) return
      const response = await this.$http({
        url: 'consulta/recibirCita',
        method: 'POST',
        params: {
          id: this.cita.citaId
        }
      })
      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Paciente recibido exitosamente'
        })
        this.cita.horaRecepcion = new Date().toISOString() // Simula la hora de recepción
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al recibir al paciente'
        })
      }
    } catch (err) {
      console.error(err)
      Swal.fire({
        icon: 'error',
        title: 'Error al recibir al paciente'
      })
    }
  },
    limpiarBusqueda() {
      this.expPaciente = ''
      this.folioCita = ''
      this.cita = null
      this.citasEncontradas = []
    },
  citaSeleccionada(cita) {
      this.cita = cita
    },
    async buscaSignos(){
  try{
    this.signosSomato = []
    const response = await this.$http({
      url: 'somatometria/listsignosencuentro',
      method: 'GET',
      params:{
        cip: this.cita.cip
      }
    })

    this.signosSomato = response.data.root || []
    this.dialogSignos = true

  }catch(err){
    console.error(err)
  }
},
    soloNumeros(campo, max) {
    this[campo] = (this[campo] || '')
      .toString()
      .replace(/\D/g, '')
      .slice(0, max)
  },
  formateaFecha(fecha){
    if(!fecha) return ''
    const f = new Date(fecha)
    return f.toLocaleString('es-MX',{
    day:'2-digit',
    month:'2-digit',
    year:'numeric',
    hour:'2-digit',
    minute:'2-digit'
})
  },
  async signosGuardados(){
  this.dialogSignos = false
  await this.buscaSignos()
  }

  },
  computed: {
  puedeRegistrarSignos() {
    return Boolean(this.cita?.horaRecepcion)
  },
    horaRecepcion() {
      return Boolean (this.cita?.horaRecepcion)
    },
    fechaCancelacion() {
      return Boolean (this.cita?.fechaCancelado)
    },
    conflictos() {
      return Boolean (this.cita?.conflicto && this.cita.conflicto.length > 0 && !this.cita?.fechaCancelado)
    },
    citaPasada(){
      return Boolean(this.cita?.citaPasada >= 1)
    },
    tiempoDeCita(){
      return Boolean(this.cita?.tiempoCita && !this.cita?.horaRecepcion && !this.cita?.fechaCancelado)
    },
    internamientoActivo(){
      return Boolean(this.cita?.internamientoActivo && !this.cita?.horaRecepcion)
    }
  }
}
</script>

<style scoped>
.label {
  font-size: 0.95rem;
  color: #757575;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.value {
  font-size: 1rem;
  font-weight: 500;
  color: #4e0404;
}
</style>

